import { CellStyle } from 'xlsx-js-style/types';

export const bold: CellStyle = {
  font: { bold: true },
};

export const center: CellStyle = {
  alignment: { horizontal: 'center' },
};

export const boldLightGrayBg: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: 'e3e3e3' } },
};

export const boldGrayBg: CellStyle = {
  font: { bold: true },
  fill: { fgColor: { rgb: 'cacaca' } },
};

export const boldCentered: CellStyle = {
  font: { bold: true },
  alignment: { horizontal: 'center' },
};

export const boldCenteredLightOrangeBg: CellStyle = {
  font: { bold: true },
  alignment: { horizontal: 'center' },
  fill: { fgColor: { rgb: 'fabf8f' } },
};

export const lightOrangeBg: CellStyle = {
  fill: { fgColor: { rgb: 'fabf8f' } },
};

export const boldRed: CellStyle = {
  font: { bold: true, color: { rgb: 'ff0000' } },
};
